// extracted by mini-css-extract-plugin
export default {"content":"byBM60","link":"cyBM60","tiles":"dyBM60","tile":"eyBM60"};